// extracted by mini-css-extract-plugin
export var voiceConversionContent = "_ld-0";